import { render, staticRenderFns } from "./gnrl_dialog.vue?vue&type=template&id=d1f18cec&scoped=true"
import script from "./gnrl_dialog.vue?vue&type=script&lang=js"
export * from "./gnrl_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f18cec",
  null
  
)

export default component.exports